import { ISystemStatusMessage } from "../../@types/systemStatus";

import { env } from "../env";

const baseUrl = env.REACT_APP_API_URL
const systemStatusBaseUrl = (process.env.REACT_APP_SYSTEMSTATUS_API_URL ?? "https://systemstatus.api.cosmogas.com").replace(/\/$/, "");

export interface IResponse {
    error?: boolean;
    message?: string;
    data?: any;
}

export async function getProduct(seriale: string) {
    try {
        const url = `${baseUrl}/api/v1/public/productInstances/${seriale}`;
        const res = await fetch(url);

        if (res.status !== 200) {
            return {
                error: true,
                message: `Server error: ${res.statusText}`,
                status: res.status
            };
        }

        const json = await res.json();

        return {
            error: false,
            data: json
        };
    } catch (error) {
        console.error("API error:", error);
        return {
            error: true,
            message: error instanceof Error ? error.message : "Unknown error",
        };
    }
}

export async function getDocs(seriale: string, skip = 0) {
    try {
        const url = new URL(`${baseUrl}/api/v1/public/productInstances/${seriale}/documents`);
        url.searchParams.set("take", "100");
        url.searchParams.set("skip", skip.toString());

        const res = await fetch(url.toString());

        if (res.status !== 200) {
            return {
                error: true,
                message: `Server error: ${res.statusText}`,
                status: res.status
            };
        }

        const json = await res.json();

        return {
            error: false,
            data: json.data,
            paging: json.paging
        };
    } catch (error) {
        console.error("API error:", error);
        return {
            error: true,
            message: error instanceof Error ? error.message : "Unknown error",
        };
    }
}

export async function getRevisionPublicUrl(documentId: string, automaticRevisionNumber: string) {
    try {
        const url = new URL(`${baseUrl}/api/v1/public/documents/${documentId}/revisions/${automaticRevisionNumber}/share`);

        const res = await fetch(url.toString());

        if (res.status !== 200) {
            throw Error(`Internal server error: ${res.statusText}`)
        }

        const json = await res.json();

        if (!json.publicUrl) {
            console.log("Error while retriving file public url");
            return;
        }

        return json.publicUrl;
    } catch (error) {
        console.log(error);
        return;
    }
}

export async function getSystemStatusMessages(audience = "lp") {
    try {
        const url = new URL(`${systemStatusBaseUrl}/api/v1/public/systemstatus/messages`);
        url.searchParams.set("audience", audience);

        const res = await fetch(url.toString());

        if (res.status !== 200) {
            return {
                error: true,
                message: `Server error: ${res.statusText}`,
                status: res.status
            };
        }

        const json = await res.json();

        return {
            error: false,
            data: (json.data ?? []) as ISystemStatusMessage[]
        };
    } catch (error) {
        console.error("SystemStatus API error:", error);
        return {
            error: true,
            message: error instanceof Error ? error.message : "Unknown error",
        };
    }
}
